import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import './CookieNotice.css';
const cookies = new Cookies();
class CookieNotice extends Component {
	constructor(props) {
		super(props);
		this.state = {showNotice: true};
		if(cookies.get('cookie-notice-accepted')==="1")
		{
			this.state = {showNotice: false};
		}
	}

	acceptCookies()
	{
		cookies.set('cookie-notice-accepted',"1",{path: '/', maxAge: 2592000});
		this.setState({ showNotice: false });
	}

	render() {
		
		return (
			<div className="cookie-notice-container" style={this.state.showNotice ? {} : { display: 'none' }}><FormattedMessage id="footer.cookieNoticeTxt" /> <button type="button" onClick={() => this.acceptCookies()}>Ok</button> <a href="https://www.w-restaurants.fi/asiakasrekisterin-tietosuojaseloste"><FormattedMessage id="footer.cookieNoticeReadMore" /></a></div>
		)
	}
}

export default connect()(injectIntl(CookieNotice));


// WEBPACK FOOTER //
// ./src/containers/CookieNotice/CookieNotice.js